import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, NavController, NavParams, Platform, ToastController } from 'ionic-angular';
import { LoaderProvider } from '../../../providers/loader/loader';
import { RegistrationModel, UserProvider } from '../../../providers/user/user';
import { SessionProvider } from '../../../providers/session/session';
import { ConfigProvider } from '../../../providers/config/config';

@Component({
  selector: 'page-registration',
  templateUrl: 'registration.html'
})
export class RegistrationPage {
  model: RegistrationModel = {
    password: '',
    password2: '',
    email: ''
  };

  resolve: any = null;
  isLoged: boolean = false;
  isIOS: boolean = false;

  rememberMe: boolean = true;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private userService: UserProvider,
    public app: App,
    private loadingCtrl: LoaderProvider,
    private translate: TranslateService,
    private toastCtrl: ToastController,
    private sessionService: SessionProvider,
    private platform: Platform
  ) {
    this.platform.ready().then(async () => {
      this.isIOS = this.platform.is('ios');

      if (this.navParams.get('resolve'))
        this.resolve = this.navParams.get('resolve');
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad RegistrationPage');
  }

  ionViewWillLeave() {
    if (this.resolve && this.isLoged) { this.resolve(true) }
  }

  reg() {
    let loader = this.loadingCtrl.create({
      content: this.translate.instant('GLOBAL_LOADING')
    });
    loader.present();
    this.model.password2 = this.model.password;
    this.userService.registration(this.model).then(result => {
      loader.dismiss().then(() => {
        if (result === true) {
          this.sessionService.sendLoggedIn();
          this.isLoged = true;
          if (this.resolve) { this.resolve(true) }
          if (this.rememberMe) {
            this.sessionService.saveLogin({ email: this.model.email, password: this.model.password });
          }
          (this.app.getRootNav() as NavController).pop();
          if (!this.resolve) this.sessionService.onTriggerPageProfileEdit();
        } else {
          console.log(this.decodeEntities(result.message));
          this.toastCtrl
            .create({
              message: this.decodeEntities(result.message),
              showCloseButton: true
            })
            .present();
        }
      });
    });
  }

  /// TODO Its just a quick fix
  decodeEntities = (() => {
    let element = document.createElement('div');
    let entity = /&(?:#x[a-f0-9]+|#[0-9]+|[a-z0-9]+);?/gi;
    return str => {
      str = str.replace(entity, function (m) {
        element.innerHTML = m;
        return element.textContent;
      });
      element.textContent = '';
      return str;
    };
  })();


  onGoogleLogin() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.loginGoogle().subscribe(success => {
      if (success) {
        this.onLogin();
      }
      loader.dismiss();
    });
  }

  onFacebookLogin() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.loginFacebook().then(success => {
      if (success) {
        this.onLogin();
      }
      loader.dismiss();
    });
  }

  onAppleLogin() {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.userService.loginApple().then(success => {
      if (success) {
        this.onLogin();
      }
      loader.dismiss();
    });
  }

  onLogin() {
    this.sessionService.isLoged = true;

    this.sessionService.sendLoggedIn();

    console.log(this.sessionService);
    // this.checkForOrganizerLogin();
    (this.app.getRootNav() as NavController).pop();
  }

  checkForOrganizerLogin() {
    if (this.sessionService.profile.status.toLocaleUpperCase().includes("VERANSTALTER")) {
      this.toastCtrl.create({
        message: this.translate.instant('ORGANIZER_LOGIN_MESSAGE'),
        duration: 5000
      }).present();
      this.userService.logout();
    }
  }
}



// WEBPACK FOOTER //
// /src/pages/login/registration/registration.ts